import {
  useCartAndDeliveryDatesDataContext,
  useUpdateShippingPreference,
} from '@app/data/clients/cartCheckoutClient';
import { trackGA4SelectShippingPreference } from '@app/pages/cart/utils/analytics';
import { ShippingMethod } from '@app/types/cart/ShippingMethod';
import { CartQueryShippingAddress } from '@app/types/monolith/types';
import { mapCartToPayPalRequiredCartFromMonolith } from './utils';

export const usePayPalShippingPreferenceChangeHandler = () => {
  const { dispatch, client } = useCartAndDeliveryDatesDataContext();

  const { handler: handleUpdateShippingPreference } =
    useUpdateShippingPreference({ client, dispatch });

  const handleShippingPreferenceChange = async (
    preference: ShippingMethod,
    shippingAddress?: CartQueryShippingAddress
  ) => {
    const result = await handleUpdateShippingPreference(
      preference,
      shippingAddress
    );

    if (result.state === 'FAILED' || !result?.data) {
      const errorMessage =
        result.errors?.[0]?.exception || 'Failed to update shipping preference';
      throw new Error(errorMessage);
    }

    trackGA4SelectShippingPreference({ shippingPreference: preference });

    return mapCartToPayPalRequiredCartFromMonolith(result.data);
  };

  return { handleShippingPreferenceChange };
};
